import { useState, useRef } from "react";
import { Overlay, Popover } from "react-bootstrap";

/* room4 침실 */

function Room4(){

  const [showBedPopover, setShowBedPopover] = useState(false);
  const [BedPopoverText, setBedPopoverText] = useState('');
  const BedRef = useRef(null);

  const handleBedClick = () => {
  setBedPopoverText("크고 푹신하다");
  setShowBedPopover(true);
  setTimeout(() => setShowBedPopover(false), 2000);
};

    return(
        <div 
        className="d-flex justify-content-center align-content-center flex-wrap" 
        style={{height: 'calc(100vh - 200px)',
        display: 'flex',
        //justifyContent: 'center',
        alignItems: 'flex-end',
        gap: '10px',
        marginTop: '0vh',
         }}>
        <button
          ref={BedRef}
          type="button"
          className="btn btn-secondary"
          onClick={handleBedClick}
          style={{
            width: '50vw',
            height: '10vh',
            backgroundColor:'#dee2e6',
            backgroundImage: 'radial-gradient(lightgrey 2px, transparent 10px)',
            backgroundSize: '5px 5px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          >침대</button>

                    
          {BedRef.current && (
            <Overlay target={BedRef.current} show={showBedPopover} placement="top">
              {(props) => (
                <Popover {...props}>
                  <Popover.Body>{BedPopoverText}</Popover.Body>
                </Popover>
              )}
            </Overlay>
          )}

          </div>
       );
}

export default Room4;

